class Cloud {
    constructor(scene) {
        const randomXPosition = Math.floor(Math.random() * 1300);
        const randomYPosition = Math.floor(Math.random() * 200) + 48;

        this.scene = scene;

        this.sprite = scene.physics.add.sprite(randomXPosition, randomYPosition, 'cloud', 0)
            .setScale(8).setGravity(0, -3000).setDepth(0);
        this.sprite.body.customBoundsRectangle.left = -500;
        this.sprite.body.customBoundsRectangle.right = 3200;
        this.update();
    }

    update() {
        if (!this.isDead && this.scene.state.started) { 
            this.sprite.setVelocityX(-150); // causing inconsistent cactus speeds?
        }

        else {
            this.sprite.setVelocityX(-0);
        }

    }

    stop() {
        this.sprite.setVelocityX(0);
    } 

}

export default Cloud; 